//
//
//
//
//
//
//
//
//
//

export default {
	name: 'ProductView',
};
